/* eslint-env node */

const noop = async () => null;
const noopSync = () => null;

module.exports = {
  getImageForFont: noop,
  getImageForFontSync: noopSync,
  createIconSource: noop,
  createIconSourceSync: noopSync,
  default: {
    getImageForFont: noop,
    getImageForFontSync: noopSync,
    createIconSource: noop,
    createIconSourceSync: noopSync,
  },
};
